/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryCloud extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryCloud");
    }

    getFixupPrototypeFunction() { return WorkloadQueryCloud.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryCloud>): WorkloadQueryCloud {
        let obj = Object.assign(new WorkloadQueryCloud(), model);
        WorkloadQueryCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryCloud>): WorkloadQueryCloud {
        if (!model) return null;
        return WorkloadQueryCloud.newInstance(<WorkloadQueryCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryCloud) {
        if (!obj) return;

        models.WorkloadQueryCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryCloud): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud providers
     */
    clouds: Array<string>;

}
